export const enum Keys {
    Banniere = "maggrp_cd",
    Magasin = "mag_num",
    Division = "div_num",
    Section = "plans_seq",
    Fournisseur = "four_cd",
    Statut = "statut_aff",
    Activite = "act_cd",
    Acheteur = "usr_cd",
    Collection = "prod_collection"
};